import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { constantsStore } from '@ai/common/src/store/ConstantsStore';
import { getUserStore } from '@ai/common/src/store/UserStore';

import { YA_REDIRECT_PAGE } from './const';
import { IUser } from '@ai/common/src/types/user';

export interface IAuthYandexProps {
  onLogin?: () => void;
}
export const AuthYandex = observer(
  ({ navigateAfterLogin }: { navigateAfterLogin: (user: IUser, balance: boolean) => void }) => {
    const { loginWithYandex } = getUserStore('platform');
    const navigate = useNavigate();

    const handleError = (error: unknown) => {
      console.error(error);
    };

    useEffect(() => {
      const initYandexButton = () => {
        if (constantsStore.authConstants?.yandexId) {
          window.YaAuthSuggest.init(
            {
              client_id: constantsStore.authConstants.yandexId.clientId,
              response_type: 'token',
              // redirect_uri: "https://oauth.yandex.ru/verification_code", // localhost
              redirect_uri: `${window.location.origin}/${YA_REDIRECT_PAGE}`,
            },
            `${window.location.protocol}//${window.location.host}`,
            {
              view: 'button',
              parentId: 'buttonLoginWithYandex',
              buttonSize: 's',
              buttonView: 'additional',
              buttonTheme: 'light',
              buttonBorderRadius: '8',
              buttonIcon: 'ya',
            }
          )
            .then(({ handler }: YaAuthInitResponse) => handler && handler())
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then(async (data: any) => {
              if (data && data.access_token) {
                try {
                  const { currentUser, hasBalance } = await loginWithYandex(data.access_token);
                  navigateAfterLogin(currentUser, hasBalance);
                } catch (error) {
                  initYandexButton();
                  console.error(error);
                }
              }
            })
            .catch(handleError);
        }
      };

      initYandexButton();
    }, [loginWithYandex, navigate, navigateAfterLogin]);

    return <div id="buttonLoginWithYandex"></div>;
  }
);
